module.exports = "pegasus_template/assets/tech/safari/105.png";